import React from 'react';
import {
  Button, IconBell, IconGift, IconStar, IconWand, Modal,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as Styles from './ModalPaidPlan.styles';
import { MODALS } from '../../logoBuilder.types';
import { logoBuilderAnalytics } from '@/analytics/logoBuilder';

const ModalPaidPlan = ({ setModalToShow, setSelectedPaidPlan }) => {
  const { logoBuilder: logoBuilderLocale } = useLocale();
  const { modalPaidPlan: modalPaidPlanLocale } = logoBuilderLocale;
  const currentDate = new Date();
  const futureDateChargeReminder = new Date(currentDate);
  futureDateChargeReminder.setDate(currentDate.getDate() + 30 - 7);
  const futureDateCharge = new Date(currentDate);
  futureDateCharge.setDate(currentDate.getDate() + 30);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const chargeDateReminder = futureDateChargeReminder.toLocaleDateString('pt-BR', options);
  const chargeDate = futureDateCharge.toLocaleDateString('pt-BR', options);

  const redirectToLogoGeneration = () => {
    setSelectedPaidPlan(true);
    setModalToShow(MODALS.LOGO_GENERATION);
    logoBuilderAnalytics.paymentContinue();
  };

  const handleCloseModal = () => {
    setModalToShow(undefined);
    logoBuilderAnalytics.paymentCloseModal();
  };

  return (
    <Modal
      maxWidth={800}
      onClose={handleCloseModal}
      testId="Modal"
      title=""
    >
      <Styles.ModalContent>
        <Styles.WrapperModalContentTitle>
          <IconWand secondaryColor="activeLight" color="lowDark" />
          <Styles.ModalContentTitle>
            {modalPaidPlanLocale.modalPaidPlanTitle}
          </Styles.ModalContentTitle>
        </Styles.WrapperModalContentTitle>

        <Styles.Steps>
          <Styles.Row>
            <Styles.Line />
            <Styles.WrapperIcon>
              <IconGift
                color="highPure"
                size="md"
                testId="IconGift"
              />
            </Styles.WrapperIcon>

            <Styles.StepItemContent>
              <Styles.StepItemTitle>
                {modalPaidPlanLocale.stepItemTitleFreeTrial}
              </Styles.StepItemTitle>
              <Styles.StepItemSubtitle>
                {modalPaidPlanLocale.stepItemSubtitleFreeTrial}
              </Styles.StepItemSubtitle>
            </Styles.StepItemContent>
          </Styles.Row>

          <Styles.Row>
            <Styles.Line />
            <Styles.WrapperIcon>
              <IconBell
                color="highPure"
                size="md"
                testId="IconBell"
              />
            </Styles.WrapperIcon>

            <Styles.StepItemContent>
              <Styles.StepItemTitle>
                {chargeDateReminder}
              </Styles.StepItemTitle>
              <Styles.StepItemSubtitle>
                {modalPaidPlanLocale.stepItemSubtitleReminder}
              </Styles.StepItemSubtitle>
            </Styles.StepItemContent>
          </Styles.Row>

          <Styles.Row>
            <Styles.WrapperIcon yellow>
              <IconStar
                backgroundColor="attentionPure"
                color="primaryExtraDark"
                direction="left"
                size="md"
                testId="IconStar"
              />
            </Styles.WrapperIcon>

            <Styles.StepItemContent>
              <Styles.StepItemTitle>
                {chargeDate}
              </Styles.StepItemTitle>
              <Styles.StepItemSubtitle>
                {modalPaidPlanLocale.stepItemSubtitleCharge}
              </Styles.StepItemSubtitle>
            </Styles.StepItemContent>
          </Styles.Row>
        </Styles.Steps>

        <Styles.BoxSummary>
          <Styles.BoxSummaryTitle>
            {modalPaidPlanLocale.boxSummaryTitle}
          </Styles.BoxSummaryTitle>
          <Styles.BoxSummaryText>
            A pagar dia
            {' '}
            {chargeDate}
            {' '}
            -
            {' '}
            <strong>R$</strong>
            {' '}
            <span className="text-big">19,99</span>
            {' '}
            <strong>mensal /</strong>
            {' '}
            <strong className="text-small">R$ 239,88 ano</strong>
          </Styles.BoxSummaryText>
          <Styles.BoxSummaryText>
            A pagar hoje
            {' '}
            <strong className="text-green">(30 dias grátis)</strong>
            {' '}
            <strong>R$0,00</strong>
          </Styles.BoxSummaryText>
        </Styles.BoxSummary>

        <Styles.Row justifyContentCenter>
          <Button
            label={modalPaidPlanLocale.buttonContinue}
            onClick={redirectToLogoGeneration}
            size="large"
            testId="button"
            type="button"
            variant="primary"
            width="fit-content"
          />
        </Styles.Row>
      </Styles.ModalContent>
    </Modal>
  );
};

export default ModalPaidPlan;
